import { sleep } from '../helpers/common';
class HubSpot {
    constructor() {
        /**
         * ページビューのトラッキング処理
         * @param path
         */
        this.trackPageView = (path) => {
            const key = '_hsq';
            if (!window[key]) {
                return;
            }
            sleep(0.1).then(() => {
                window[key].push(['setPath', path]);
                window[key].push(['trackPageView']);
            });
        };
        /**
         * チャットボット表示の初期optionsを設定する
         * @param options
         */
        this.setHsConversationsSettings = (options = {}) => {
            window.hsConversationsSettings = Object.assign({ loadImmediately: false }, options);
        };
        /**
         * チャットボット表示用のHubSpotのリソースが存在するか
         * @returns {boolean|*}
         */
        this.existsHubSpotConversations = () => !!window.HubSpotConversations;
        /**
         * チャットボットがロード済みか
         * @returns {boolean|*}
         */
        this.isLoadedChat = () => {
            if (!this.existsHubSpotConversations()) {
                return false;
            }
            const status = window.HubSpotConversations.widget.status();
            return status.loaded;
        };
        /**
         * チャットボットのコンポーネントを表示する
         */
        this.loadChat = () => {
            if (!this.isLoadedChat()) {
                window.HubSpotConversations.widget.load();
            }
        };
        /**
         * チャットボットのコンポーネントを非表示にする
         */
        this.removeChat = () => {
            if (this.isLoadedChat()) {
                window.HubSpotConversations.widget.remove();
            }
        };
        /**
         * チャットボットの会話ウィンドウを開く
         */
        this.openChat = () => {
            window.HubSpotConversations.widget.open();
        };
        /**
         * チャットボットの会話ウィンドウを閉じる
         */
        this.closeChat = () => {
            window.HubSpotConversations.widget.close();
        };
    }
}
export default new HubSpot();
